import { Container, Grid, Paper } from "@mui/material";
import Rankings from "../../Components/Rankings";

import { useState, useEffect } from "react";

const BALeaderboard = () => {
  const [rankings, setRankings] = useState<any[]>([]);

  useEffect(() => {
    const fetchRankings = async () => {
      try {
        const response = await fetch(
          `${import.meta.env.VITE_API_URL}/analytics/ba-rankings`
        ); // Placeholder API endpoint
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setRankings(data);
        console.log(data);
      } catch (error) {
        console.error("Failed to fetch rankings:", error);
      }
    };

    fetchRankings();
  }, []);

  const columns = [
    { id: "rank", label: "Rank" },
    { id: "full_name", label: "Name" },
    { id: "agency", label: "Agency" },
    { id: "total_sales", label: "Total Sold" },
    { id: "sales_per_hour", label: "Avg. Sold" },
  ];

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper
            elevation={3}
            sx={{
              p: 3,
              backgroundColor: "background.paper",
              borderRadius: 2,
            }}
          >
            <Rankings columns={columns} data={rankings} />
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default BALeaderboard;
